var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTt = function SvgTt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.498 1.332a11.993 11.993 0 0 0-2.983 2.182c-.9.9-1.628 1.909-2.182 2.983l7.716 8.454 8.454 7.716a11.993 11.993 0 0 0 2.983-2.182c.9-.9 1.627-1.909 2.182-2.983l-7.716-8.454-8.454-7.716Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.486 20.486c.503-.503.952-1.04 1.347-1.604L5.12 2.167A12.07 12.07 0 0 0 2.167 5.12l16.715 16.715c.563-.396 1.1-.845 1.604-1.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.514 20.486C7.3 24.273 12.986 25 17.502 22.668L1.332 6.498C-.997 11.016-.27 16.702 3.515 20.487ZM20.485 3.515C16.699-.271 11.013-.998 6.497 1.333l16.17 16.17c2.33-4.517 1.604-10.202-2.182-13.988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTt;